import { api } from 'api'

type GetEmployerGuidanceRequest = {
  positionId: number
  locationId: number
  mileage?: number
  shiftDurationHours: number
}

type GetEmployerGuidanceResponse = {
  employerGuidance: {
    minimumPayRate: string | number
    minimumPayLumpSum: string | number
    hideBonus?: boolean
  }
}

export async function getEmployerGuidance(options: GetEmployerGuidanceRequest) {
  const { positionId, locationId, mileage, shiftDurationHours } = options

  const result = await api.post<GetEmployerGuidanceResponse>(
    '/company/graphql_dispatch/employer_guidance_029285ba',
    {
      positionId,
      locationId,
      mileage,
      shiftDurationHours,
    }
  )

  const { employerGuidance } = result.data

  return {
    ...employerGuidance,
    minimumPayRate: Number(employerGuidance.minimumPayRate),
    minimumPayLumpSum: Number(employerGuidance.minimumPayLumpSum),
  }
}
